const { range } = require("d3");
var d3 = require("d3");

var dataviz = document.getElementById('dataviz-chart-aduhelm-cost');

var data1 = [{ "company": "Regeneron", "ceo": "Leonard Schleifer", "value": 452855658 },
    { "company": "Align Technology", "ceo": "Joe Hogan", "value": 113439745 },
    { "company": "Oak Street Health", "ceo": "Mike Pykosz", "value": 92506982 },
    { "company": "Cigna", "ceo": "David Cordani", "value": 91186834 },
    { "company": "Progyny, Inc.", "ceo": "David Schlanger", "value": 80351628 },
    { "company": "Edwards Lifesciences", "ceo": "Michael Mussallem", "value": 76745573 },
    { "company": "Guardant Health", "ceo": "Helmy Eltoukhy", "value": 75551560 },
    { "company": "Horizon Therapeutics", "ceo": "Tim Walbert", "value": 70089338 },
    { "company": "Hologic", "ceo": "Steve MacMillan", "value": 68527405 },
    { "company": "BridgeBio Pharma, Inc.", "ceo": "Neil Kumar", "value": 62781129 }
];

var data2 = [{ "company": "Regeneron Pharmaceuticals", "ceo": "Leonard Schleifer", "value": 6707 },
    { "company": "Align Technology", "ceo": "Joe Hogan", "value": 1680 },
    { "company": "Oak Street Health", "ceo": "Mike Pykosz", "value": 1370 },
    { "company": "Cigna", "ceo": "David Cordani", "value": 1350 },
    { "company": "Progyny, Inc.", "ceo": "David Schlanger", "value": 1190 },
    { "company": "Edwards Lifesciences", "ceo": "Michael Mussallem", "value": 1137 },
    { "company": "Guardant Health", "ceo": "Helmy Eltoukhy", "value": 1119 },
    { "company": "Horizon Therapeutics", "ceo": "Tim Walbert", "value": 1038 },
    { "company": "Hologic", "ceo": "Steve MacMillan", "value": 1015 },
    { "company": "BridgeBio Pharma, Inc.", "ceo": "Neil Kumar", "value": 930 }
];

var dataHouse = [{ "company": "Regeneron Pharmaceuticals", "ceo": "Leonard Schleifer", "value": 1056 },
    { "company": "Align Technology", "ceo": "Joe Hogan", "value": 265 },
    { "company": "Oak Street Health", "ceo": "Mike Pykosz", "value": 216 },
    { "company": "Cigna", "ceo": "David Cordani", "value": 213 },
    { "company": "Progyny, Inc.", "ceo": "David Schlanger", "value": 187 },
    { "company": "Edwards Lifesciences", "ceo": "Michael Mussallem", "value": 179 },
    { "company": "Guardant Health", "ceo": "Helmy Eltoukhy", "value": 176 },
    { "company": "Horizon Therapeutics", "ceo": "Tim Walbert", "value": 163 },
    { "company": "Hologic", "ceo": "Steve MacMillan", "value": 160 },
    { "company": "BridgeBio Pharma, Inc.", "ceo": "Neil Kumar", "value": 146 }
];

var dataCar = [{ "company": "Regeneron Pharmaceuticals", "ceo": "Leonard Schleifer", "value": 3549 },
    { "company": "Align Technology", "ceo": "Joe Hogan", "value": 889 },
    { "company": "Oak Street Health", "ceo": "Mike Pykosz", "value": 725 },
    { "company": "Cigna", "ceo": "David Cordani", "value": 715 },
    { "company": "Progyny, Inc.", "ceo": "David Schlanger", "value": 630 },
    { "company": "Edwards Lifesciences", "ceo": "Michael Mussallem", "value": 602 },
    { "company": "Guardant Health", "ceo": "Helmy Eltoukhy", "value": 592 },
    { "company": "Horizon Therapeutics", "ceo": "Tim Walbert", "value": 549 },
    { "company": "Hologic", "ceo": "Steve MacMillan", "value": 537 },
    { "company": "BridgeBio Pharma, Inc.", "ceo": "Neil Kumar", "value": 492 }
];

var dataPlane = [{ "company": "Regeneron Pharmaceuticals", "ceo": "Leonard Schleifer", "value": 99 },
    { "company": "Align Technology", "ceo": "Joe Hogan", "value": 25 },
    { "company": "Oak Street Health", "ceo": "Mike Pykosz", "value": 20 },
    { "company": "Cigna", "ceo": "David Cordani", "value": 20 },
    { "company": "Progyny, Inc.", "ceo": "David Schlanger", "value": 17 },
    { "company": "Edwards Lifesciences", "ceo": "Michael Mussallem", "value": 17 },
    { "company": "Guardant Health", "ceo": "Helmy Eltoukhy", "value": 16 },
    { "company": "Horizon Therapeutics", "ceo": "Tim Walbert", "value": 15 },
    { "company": "Hologic", "ceo": "Steve MacMillan", "value": 15 },
    { "company": "BridgeBio Pharma, Inc.", "ceo": "Neil Kumar", "value": 14 }
];

var dataPhones = [{ "company": "Regeneron Pharmaceuticals", "ceo": "Leonard Schleifer", "value": 566778 },
    { "company": "Align Technology", "ceo": "Joe Hogan", "value": 141977 },
    { "company": "Oak Street Health", "ceo": "Mike Pykosz", "value": 115778 },
    { "company": "Cigna", "ceo": "David Cordani", "value": 114126 },
    { "company": "Progyny, Inc.", "ceo": "David Schlanger", "value": 100565 },
    { "company": "Edwards Lifesciences", "ceo": "Michael Mussallem", "value": 96052 },
    { "company": "Guardant Health", "ceo": "Helmy Eltoukhy", "value": 94558 },
    { "company": "Horizon Therapeutics", "ceo": "Tim Walbert", "value": 87721 },
    { "company": "Hologic", "ceo": "Steve MacMillan", "value": 85766 },
    { "company": "BridgeBio Pharma, Inc.", "ceo": "Neil Kumar", "value": 78575 }
];

var dataTuition = [{ "company": "Regeneron Pharmaceuticals", "ceo": "Leonard Schleifer", "value": 42165 },
    { "company": "Align Technology", "ceo": "Joe Hogan", "value": 10562 },
    { "company": "Oak Street Health", "ceo": "Mike Pykosz", "value": 8613 },
    { "company": "Cigna", "ceo": "David Cordani", "value": 8490 },
    { "company": "Progyny, Inc.", "ceo": "David Schlanger", "value": 7482 },
    { "company": "Edwards Lifesciences", "ceo": "Michael Mussallem", "value": 7146 },
    { "company": "Guardant Health", "ceo": "Helmy Eltoukhy", "value": 7035 },
    { "company": "Horizon Therapeutics", "ceo": "Tim Walbert", "value": 6526 },
    { "company": "Hologic", "ceo": "Steve MacMillan", "value": 6381 },
    { "company": "BridgeBio Pharma, Inc.", "ceo": "Neil Kumar", "value": 5846 }
];

var size = {
    width: 900,
    height: 340
}

var margin = {
    top: 20,
    left: 132,
    right: 45,
    bottom: 40
}

var width = 710 - margin.left - margin.right;
var height = 700 - margin.top - margin.bottom;

// add controls

var theControls = d3.select("#dataviz-chart-aduhelm-cost").append("div").attr("class", "comp-chart-controls");

theControls.append("div")
    .html("What you could buy if you were one of health care’s highest-paid CEOs")
    .attr("class", "chart-title")

theControls.append("div")
    .html("Choose a unit")
    .attr("class", "range-slider-label")

var buttonOne = theControls.append("button")
    .attr("class", "control-button dollars")
    .html("US Dollars")
    .on("click", function() { update(data1, "regular") });

var buttonTwo = theControls.append("button")
    .attr("class", "control-button phones")
    .html("iPhone 13")
    .on("click", function() { update(dataPhones, "phones") });

var buttonTuition = theControls.append("button")
    .attr("class", "control-button tuition")
    .html("Avg. year in-state tuition")
    .on("click", function() { update(dataTuition, "tuition") });

var buttonIncomes = theControls.append("button")
    .attr("class", "control-button incomes")
    .html("Median US Household Income")
    .on("click", function() { update(data2, "incomes") });

var buttonFour = theControls.append("button")
    .attr("class", "control-button teslas")
    .html("Tesla Model S Plaid")
    .on("click", function() { update(dataCar, "cars") });

var buttonThree = theControls.append("button")
    .attr("class", "control-button houses")
    .html("Median US Home Price")
    .on("click", function() { update(dataHouse, "houses") });


var buttonFive = theControls.append("button")
    .attr("class", "control-button planes")
    .html("Cessna M2")
    .on("click", function() { update(dataPlane, "planes") });


var svg = d3.select("#dataviz-chart-aduhelm-cost").append("svg")
    .attr("width", width + margin.left + margin.right)
    .attr("height", height + margin.top + margin.bottom)
    .append("g")
    .attr("transform",
        "translate(" + margin.left + "," + margin.top + ")");

// define patterns

svg
    .append('defs')
    .append('pattern')
    .attr('id', 'moneyPattern')
    .attr('patternUnits', 'userSpaceOnUse')
    .attr('width', 4)
    .attr('height', 3)
    .append('svg:image')
    .attr("xlink:href", "vendor/1x/money-icon.png")
    .attr("width", 4)
    .attr("height", 3)
    .attr("x", 0)
    .attr("y", 0);

svg
    .append('defs')
    .append('pattern')
    .attr('id', 'housePattern')
    .attr('patternUnits', 'userSpaceOnUse')
    .attr('width', 11)
    .attr('height', 11)
    .append('svg:image')
    .attr("xlink:href", "vendor/1x/house-icon.png")
    .attr('width', 11)
    .attr('height', 11)
    .attr("x", 0)
    .attr("y", 0);

svg
    .append('defs')
    .append('pattern')
    .attr('id', 'carPattern')
    .attr('patternUnits', 'userSpaceOnUse')
    .attr('width', 7)
    .attr('height', 7)
    .append('svg:image')
    .attr("xlink:href", "vendor/1x/car-icon.png")
    .attr('width', 7)
    .attr('height', 7)
    .attr("x", 0)
    .attr("y", 0);

svg
    .append('defs')
    .append('pattern')
    .attr('id', 'planePattern')
    .attr('patternUnits', 'userSpaceOnUse')
    .attr('width', 17)
    .attr('height', 17)
    .append('svg:image')
    .attr("xlink:href", "vendor/1x/plane-icon.png")
    .attr('width', 17)
    .attr('height', 17)
    .attr("x", 0)
    .attr("y", 0);

svg
    .append('defs')
    .append('pattern')
    .attr('id', 'phonePattern')
    .attr('patternUnits', 'userSpaceOnUse')
    .attr('width', 3)
    .attr('height', 3)
    .append('svg:image')
    .attr("xlink:href", "vendor/1x/phone-icon.png")
    .attr('width', 3)
    .attr('height', 3)
    .attr("x", 0)
    .attr("y", 0);


// Add X axis
var x = d3.scaleLinear()
    .domain([0, d3.max(data1, function(d) { return d.value; })])
    .range([0, width]);
svg.append("g")
    .attr("id", "mainXaxis")
    .attr("class", "x axis")
    .attr("transform", "translate(0," + height + ")")
    .call(d3.axisBottom(x).tickFormat(d3.format(".2s")))
    .selectAll("text")
    .attr("font-size", "14px")
    .attr("font-family", "Circular, sans-serif")
    .style("text-anchor", "middle");

svg.append("g")
    .attr("id", "xGrid")
    .attr("transform", "translate(0," + height + ")")
    .call(d3.axisBottom(x).tickSize(-height).tickFormat(''))
    .selectAll("line")
    .attr("class", "xGridLines")

// Y axis
var y = d3.scaleBand()
    .range([0, height])
    .domain(data1.map(function(d) { return d.ceo; }))
    .padding(.12);

var y2 = d3.scaleBand()
    .range([0, height])
    .domain(data1.map(function(d) { return d.company; }))
    .padding(.12);
svg.append("g")
    .attr("id", "mainYaxis")
    .call(d3.axisLeft(y))
    .attr("font-size", "14px")
    .attr("font-weight", "bold")
    .attr("font-family", "Circular, sans-serif")

svg.selectAll(".text")
    .data(data1)
    .enter()
    .append("text")
    .attr("font-size", "12px")
    .attr("font-family", "Circular, sans-serif")
    .attr("class", "label")
    .attr("x", -10)
    .attr("y", function(d) { return y(d.ceo) + 0; })
    .attr("dy", "42px")
    .text(function(d) { return d.company; })
    .style("text-anchor", "end");

// A function that create / update the plot for a given variable:
function update(data, variable) {

    var theFill = "";

    if (variable === "regular") {
        theFill = "#1fadb6"
    } else if (variable === "incomes") {
        theFill = "#2c7339"
    } else if (variable === "houses") {
        theFill = "#8c3157"
    } else if (variable === "cars") {
        theFill = "#c44231"
    } else if (variable === "planes") {
        theFill = "#005182"
    } else if (variable === "phones") {
        theFill = "#8f8f06"
    } else if (variable === 'tuition') {
        theFill = "#4c565e"
    }

    var u = svg.selectAll("rect")
        .data(data)

    u
        .enter()
        .append("rect")
        .merge(u)
        .transition()
        .ease(d3.easeCubicOut)
        .duration(200)
        .attr("x", x(0))
        .attr("y", function(d) { return y(d.ceo); })
        .attr("width", function(d) { return x(d.value); })
        .attr("height", y.bandwidth())

    var theLabs = svg.selectAll(".values")
        .data(data);

    var textLabs = theLabs
        .enter()
        .append("text")
        .attr('class', 'values')
        .attr('opacity', 0)
        .attr("x", 0)
        .attr("y", function(d) { return y(d.ceo) + 18; })
        .attr('text-anchor', 'start')

    textLabs
        .merge(theLabs)
        .transition()
        .ease(d3.easeCubicOut)
        .duration(200)
        .delay(0)
        .attr('opacity', 1)
        .attr("font-family", "Circular, sans-serif")
        .attr("font-weight", "bold")
        .attr("x", (function(d) { return x(d.value) + 8; }))
        .attr("y", function(d) { return y(d.ceo) + 19; })
        .attr("dy", ".75em")
        .attr('text-anchor', 'start')
        .text(function(d) {
            if (d.value > 100000) {
                return d3.format(".3s")(d.value);
            } else if (d.value > 1000) {
                return d3.format(",.4r")(d.value);
            } else {
                return d3.format(",.2r")(d.value);
            }
        });

    x.domain([0, d3.max(data, function(d) { return d.value; })]);

    var axisEl = svg.select("#mainXaxis");

    axisEl.transition()
        .duration(1000)
        .ease(d3.easeCubicIn)
        .delay(200)
        .call(d3.axisBottom(x).tickFormat(d3.format(".2s")))
        .selectAll("text")
        .attr("font-size", "14px")
        .attr("font-family", "Circular, sans-serif")
        .style("text-anchor", "middle");

    var axisGrid = svg.select("#xGrid");

    axisGrid.transition()
        .duration(1000)
        .ease(d3.easeCubicIn)
        .delay(200)
        .call(d3.axisBottom(x).tickSize(-height).tickFormat(''))
        .selectAll("line")
        .attr("class", "xGridLines")


    u
        .enter()
        .append("rect")
        .merge(u)
        .transition()
        .duration(1000)
        .ease(d3.easeCubicIn)
        .delay(200)
        .attr("fill", theFill)
        .attr("x", x(0))
        .attr("y", function(d) { return y(d.ceo); })
        .attr("width", function(d) { return x(d.value); })
        .attr("height", y.bandwidth());

    textLabs
        .merge(theLabs)
        .transition()
        .ease(d3.easeCubicIn)
        .duration(1000)
        .delay(200)
        .attr('opacity', 1)
        .attr("font-family", "Circular, sans-serif")
        .attr("font-weight", "bold")
        .attr("x", (function(d) { return x(d.value) + 8; }))
        .attr("y", function(d) { return y(d.ceo) + 19; })
        .attr("dy", ".75em")
        .attr('text-anchor', 'start')
        .text(function(d) {
            if (d.value > 100000) {
                return d3.format(".3s")(d.value);
            } else if (d.value > 1000) {
                return d3.format(",.4r")(d.value);
            } else {
                return d3.format(",.2r")(d.value);
            }
        });

    theLabs
        .exit()
        .transition()
        .duration(500)
        .attr('opacity', 0)
        .attr('height', 0)
        .attr('y', height)
        .attr('x', 0)
        .remove();

}

// Initialize the plot with the first dataset

var u = svg.selectAll("rect")
    .data(data1)

u
    .enter()
    .append("rect")
    .merge(u)
    .attr("fill", "#007f90")
    .attr("x", x(0))
    .attr("y", function(d) { return y(d.ceo); })
    .attr("width", function(d) { return x(d.value); })
    .attr("height", y.bandwidth())

// svg.selectAll(".label")
//     .data(data1)
//     .enter()
//     .append("text")
//     .attr("class", "label")
//     .attr("font-family", "Circular, sans-serif")
//     .attr("x", (function(d) { return x(d.value) + 5; }))
//     .attr("y", function(d) { return y(d.ceo) + 18; })
//     .attr("dy", ".75em")
//     .text(function(d) {
//         if (d.value > 100000) {
//             return d3.format(".3s")(d.value);
//         } else {
//             return d3.format(",.2r")(d.value);
//         }
//     });

update(data1, "regular")


console.log("test");